function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useMemo } from 'react';
import { SortMinor } from '@shopify/polaris-icons';
import { FilterButton } from '../FilterButton/FilterButton.js';
import { ChoiceList } from '../../../ChoiceList/ChoiceList.js';
import { DirectionButton } from './components/DirectionButton/DirectionButton.js';
import { useI18n } from '../../../../utilities/i18n/hooks.js';
import { Tooltip } from '../../../Tooltip/Tooltip.js';
import { Icon } from '../../../Icon/Icon.js';
import { Popover } from '../../../Popover/Popover.js';
import { Box } from '../../../Box/Box.js';
var SortButtonDirection;

(function (SortButtonDirection) {
  SortButtonDirection["Asc"] = "asc";
  SortButtonDirection["Desc"] = "desc";
})(SortButtonDirection || (SortButtonDirection = {}));

function SortButton(_ref) {
  var choices = _ref.choices,
      selected = _ref.selected,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      onChangeKey = _ref.onChangeKey,
      onChangeDirection = _ref.onChangeDirection;

  var _selectedChoices$, _selectedChoices$2, _selectedChoices$3, _selectedChoices$4;

  var i18n = useI18n();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _selected$0$split = selected[0].split(' '),
      _selected$0$split2 = _slicedToArray(_selected$0$split, 2),
      selectedValueKey = _selected$0$split2[0],
      selectedDirection = _selected$0$split2[1];

  function handleClick() {
    setActive(function (pastActive) {
      return !pastActive;
    });
  }

  function handleClose() {
    setActive(false);
  }

  function handleChangeChoiceList(sel) {
    if (onChangeKey) {
      var _sel$0$split = sel[0].split(' '),
          _sel$0$split2 = _slicedToArray(_sel$0$split, 1),
          key = _sel$0$split2[0];

      onChangeKey(key);
    } else {
      onChange(sel);
    }
  }

  function handleChangeDirection(sel) {
    if (onChangeDirection) {
      var _sel$0$split3 = sel[0].split(' '),
          _sel$0$split4 = _slicedToArray(_sel$0$split3, 2),
          direction = _sel$0$split4[1];

      onChangeDirection(direction);
    } else {
      onChange(sel);
    }
  }

  var choiceListChoices = useMemo(function () {
    var choiceCategories = choices.reduce(function (acc, curr) {
      var alreadyExists = acc.some(function (option) {
        return option.label === curr.label;
      });

      var _curr$value$split = curr.value.split(' '),
          _curr$value$split2 = _slicedToArray(_curr$value$split, 2),
          currentValueDirection = _curr$value$split2[1];

      var isSameDirection = currentValueDirection === selectedDirection;

      if (!alreadyExists) {
        return [].concat(_toConsumableArray(acc), [curr]);
      }

      if (isSameDirection) {
        return acc.map(function (option) {
          if (option.label === curr.label) {
            return curr;
          }

          return option;
        });
      }

      return acc;
    }, []);
    return choiceCategories;
  }, [choices, selectedDirection]);
  var selectedChoices = choices.filter(function (choice) {
    var _choice$value$split = choice.value.split(' '),
        _choice$value$split2 = _slicedToArray(_choice$value$split, 1),
        currentKey = _choice$value$split2[0];

    return currentKey === selectedValueKey;
  });
  var sortButton = /*#__PURE__*/React.createElement(Tooltip, {
    content: i18n.translate('Polaris.IndexFilters.SortButton.tooltip'),
    preferredPosition: "above",
    hoverDelay: 400
  }, /*#__PURE__*/React.createElement(FilterButton, {
    onClick: handleClick,
    "aria-label": i18n.translate('Polaris.IndexFilters.SortButton.ariaLabel'),
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    source: SortMinor,
    color: "base"
  })));
  return /*#__PURE__*/React.createElement(Popover, {
    active: active && !disabled,
    activator: sortButton,
    autofocusTarget: "first-node",
    onClose: handleClose,
    fluidContent: true
  }, /*#__PURE__*/React.createElement(Box, {
    minWidth: "148px",
    padding: "4",
    borderBlockEndWidth: "1",
    borderColor: "border-subdued"
  }, /*#__PURE__*/React.createElement(ChoiceList, {
    title: i18n.translate('Polaris.IndexFilters.SortButton.title'),
    choices: choiceListChoices,
    selected: selected,
    onChange: handleChangeChoiceList
  })), /*#__PURE__*/React.createElement(Box, {
    padding: "4"
  }, /*#__PURE__*/React.createElement(DirectionButton, {
    direction: "asc",
    active: selectedDirection === SortButtonDirection.Asc,
    onClick: handleChangeDirection,
    value: selectedChoices === null || selectedChoices === void 0 ? void 0 : (_selectedChoices$ = selectedChoices[0]) === null || _selectedChoices$ === void 0 ? void 0 : _selectedChoices$.value
  }, selectedChoices === null || selectedChoices === void 0 ? void 0 : (_selectedChoices$2 = selectedChoices[0]) === null || _selectedChoices$2 === void 0 ? void 0 : _selectedChoices$2.directionLabel), /*#__PURE__*/React.createElement(DirectionButton, {
    direction: "desc",
    active: selectedDirection === SortButtonDirection.Desc,
    onClick: handleChangeDirection,
    value: selectedChoices === null || selectedChoices === void 0 ? void 0 : (_selectedChoices$3 = selectedChoices[1]) === null || _selectedChoices$3 === void 0 ? void 0 : _selectedChoices$3.value
  }, selectedChoices === null || selectedChoices === void 0 ? void 0 : (_selectedChoices$4 = selectedChoices[1]) === null || _selectedChoices$4 === void 0 ? void 0 : _selectedChoices$4.directionLabel)));
}

export { SortButton, SortButtonDirection };